var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLock1 = function SvgLock1(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 11,
    "data-width-24": 17,
    viewBox: "0 0 11 13",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.667 2.75c0-.608.23-1.03.554-1.308C4.555 1.156 5.018 1 5.5 1s.944.156 1.279.442c.323.278.554.7.554 1.308V4.5H3.667zm-1 1.75V2.75c0-.892.352-1.595.903-2.067C4.11.219 4.815 0 5.5 0s1.389.22 1.93.683c.55.472.903 1.175.903 2.067V4.5H9a2 2 0 0 1 2 2V11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6.5a2 2 0 0 1 2-2zm5.166 1H2a1 1 0 0 0-1 1V11a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V6.5a1 1 0 0 0-1-1zM6.667 8.417c0 .48-.27.896-.667 1.105v.978a.5.5 0 0 1-1 0v-.905a1.25 1.25 0 1 1 1.667-1.178",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLock1);
export default ForwardRef;